<template>
  <div>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">Montant (xof)</th>
          <th scope="col">Client</th>
          <th scope="col">Status</th>
          <th scope="col">Date</th>
          <th scope="col" v-if="site == 'hotel'">Chambre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in payments" :key="index" v-if="item.payment">
          <th scope="row">{{ index + 1 }}</th>

          <td>
            {{ item.payment.amount }}</td>
          <td>
            {{ item.customer.name }} <br> {{ item.customer.telephone }}</td>
          <td v-if="item.state == 1">
            <span class="text-success">éffectué</span>
          </td>
          <td v-else>
            <span class="text-danger">Echec</span>
          </td>
          <td>
            {{ item.updated_at.trim().substr(0, 10) }} </td>
          <td v-if="site == 'hotel'">
            {{ item.room.room_number }} </td>



        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import API from '../services/api-request';
export default {
  data() {
    return {
      site: '',
      payments: ''
    }
  },
  methods: {
    getInfo() {
      let site = this.$route.params.site;
      let id = this.$route.params.id;
      this.site = site;
      API.show(id, site + '-booking-of').then((response) => {
        this.payments = response.data['data'];
      })
    }
  },
  mounted() {
    this.getInfo()
  },
}
</script>